import React from 'react';

interface EnvContextProps {
    /**
     * The reCAPTCHA site key. Passed from the consuming application (which
     * receives it from its own backend/BFF config). Used only when the widget
     * decides a captcha is required (see `shouldShowCaptcha`).
     */
    captchaKey: string;
    /**
     * Same-origin BFF path the contact POST is sent to. Must contain `{id}`
     * where the organizer id goes. Defaults to `/api/organizers/{id}/contact/`.
     * The consuming Valkyrie app owns this route (client → own BFF → Core).
     */
    bffContactPath?: string;
}

export const EnvContext = React.createContext<Partial<EnvContextProps>>({});
